<template>
    <div>
        <!-- Filter Start -->
        <custom-filter
            :getFilterOnStart="true"
            :hideFilterVariant="true"
            @filterChange="changeFilter"
        ></custom-filter>
        <!-- Filter End -->

        <!-- Table Start -->
        <!-- <div class="bg-white shadow box-content mt-5">
            <div class="row">
                <div class="col-md-8">
                    <h5 class="elegant--sub-title">
                        Customer Report
                        <i
                            class="fas fa-info-circle"
                            id="history-report"
                        ></i>
                        <b-popover target="history-report" triggers="hover" placement="top">
                            <template #title>Customer Report</template>
                            <div v-html="tooltip.consumer_report"></div>
                        </b-popover>
                    </h5>
                </div>
            </div>
            <vue-universal-table
                api_url="/api/reports/customer-report/table"
                :filter="vue_universal_table.filter"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                :process_data="vue_universal_table.process_data"

                sort_order="DESC"
                sort_by="scan_date"
            ></vue-universal-table>
        </div> -->
        <!-- Table End -->

        <!-- Table Start -->
        <div class="bg-white shadow box-content mt-4">
            <div class="row">
                <div class="col-md-8">
                    <h5 class="elegant--sub-title">
                        Not Found Report
                        <i
                            class="fas fa-info-circle"
                            id="history-report"
                        ></i>
                        <b-popover target="history-report" triggers="hover" placement="top">
                            <template #title>Not Found Report</template>
                            <div v-html="tooltip.consumer_report"></div>
                        </b-popover>
                    </h5>
                </div>
            </div>
            <div class="mt-3">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th @click="sort('ip')">Variant</th>
                            <th @click="sort('url')">URL</th>
                            <th @click="sort('createdAt')">Created At</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(post, scan_date) in sortedTable" 
                            :key="scan_date"
                            :options="[]"
                            :filter="filter"
                            >
                            <td class="align-middle" v-text="post.ip"></td>
                            <td class="align-middle" v-text="post.url"></td>
                            <td class="align-middle" >{{ moment(post.createdAt).format('MMM DD Y, HH:mm') }}</td>
                            <td class="align-middle">
                                <button class="btn btn-primary">
                                    <i class="far fa-image"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>  
            <b-pagination
                v-model="currentPage"
                :total-rows="meta.totalRows"
                :per-page="pageSize"
                @change="handlePageChange"
                class="my-4"
                aria-controls="my-table">
            </b-pagination>
        </div>
        <!-- Table End -->
        
        <!-- Table Start -->
        <!-- <div class="bg-white shadow box-content mt-4">
            <div class="row">
                <div class="col-md-8">
                    <h5 class="elegant--sub-title">
                        Customer Report
                        <i
                            class="fas fa-info-circle"
                            id="history-report"
                        ></i>
                        <b-popover target="history-report" triggers="hover" placement="top">
                            <template #title>Customer Report</template>
                            <div v-html="tooltip.consumer_report"></div>
                        </b-popover>
                    </h5>
                </div>
            </div>
            <div class="mt-3">
                <div class="row" style="display:flex; row-gap:10px"> 
                    <div class="item col-md-4" v-for="(post, scan_date) in table" :key="scan_date">
                        <div class="card-body" style="color:white; text-align:center">
                            <h2>{{ post.variant }}</h2>
                            <h2>{{ post.volume }}</h2>
                            <h2>{{ post.url }}</h2>
                            <h2>{{ post.reason }}</h2>
                            <h2>{{ post.scan_date }}</h2>
                            <h2>{{ post.lat }}</h2>
                            <h2>{{ post.lng }}</h2>
                        <img :src="post.file" id="itemimg"/>

                        </div>
                    </div>
                </div>
            </div>  
            <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                @change="handlePageChange"
            ></b-pagination>
        </div> -->
        <!-- Table End -->

        <!-- Modal Start -->
        <!-- <report-customer-modal
            v-if="modal.view"
            @closeModal="modal.view = false"
        ></report-customer-modal> -->
        <!-- Modal End -->

    </div>
</template>

<script>
    // import moment from 'moment';
    import customFilter from '@/components/filter/customFilter'
    // import reportCustomerModal from '@/components/filter/reportCustomerModal'
    // import highlightStats from './children/HighlightStats'
    import moment from 'moment'
    
    // import customerReportChart from './children/customerReportChart.vue'

    export default {
        metaInfo : {
            title : 'Reports - Not Found Report'
        },
        data () {
            return {
                moment,
                tooltip : this.$store.state.tooltip.reports,
                filter : [],
                data : [],
                options : [],
                meta : {},
                vue_universal_table : {
                    fields : [
                        {title:"Variant", variable:"variant"},
                        {title:"Volume", variable:"volume"},
                        {title:"URL", variable:"url"},
                        {title:"Alasan", variable:"reason"},
                        {title:"Tanggal Scan", variable:"scan_date"},
                        {title:"Latitude", variable:"lat"},
                        {title:"Longitude", variable:"lng"},
                        {title:"Gambar", variable:"file"},
                    ],
                    filter : {},
                    update : 0,
                    process_data : `
                        for (var i in data) data[i].volume = (parseInt(data[i].volume))/1000 + ' Lt'

                        for (var i in data) {
                            data[i].variant = data[i].variant ? data[i].variant : '-'
                            data[i].volume = data[i].volume ? data[i].volume : '-'
                            data[i].url = data[i].url ? data[i].url : '-'
                            data[i].reason = data[i].reason ? data[i].reason : '-'
                            data[i].scan_date = data[i].scan_date ? data[i].scan_date : '-'
                            data[i].lat = data[i].lat ? data[i].lat : '-'
                            data[i].lng = data[i].lng ? data[i].lng : '-'
                            data[i].file = data[i].file ? data[i].file : '-'
                        }
                    `
                },

                // separated 1
                page: 1,

                // separated 2
                table : [],
                file : [],
                post : [],
                currentSort : 'scan_date',
                currentSortDir : 'asc',
                pageSize : 15,
                currentPage : 1,
                saveFilter : null
            }
        },
        components : {
            customFilter,
            // reportCustomerModal,
            // highlightStats,
            
            // customerReportChart,
        },
        mounted () {
            this.getTable();
            // this.changeFilter()
        },
        methods : {
            changeFilter (filter) {
                for (var i in filter) {
                    this.filter[i] = filter[i];
                    this.vue_universal_table.filter[i] = filter[i];
                }
                this.currentPage = 1

                this.saveFilter = filter

                // console.log(filter)

                //Delete unnecessary filter for the table
                delete this.vue_universal_table.filter.filter;
                // console.log(this.filter);
                this.getTable(filter);
                // this.vue_universal_table.update++;
            },

            // separated 1
            getTable(filter = {}) {
                let start = filter.start ? filter.start : new moment().startOf('year').format('Y-MM-DD')
                let end = filter.end ? filter.end : new moment().endOf('year').format('Y-MM-DD')
                const URL = `api/log/notfound?start=${start}&end=${end}&page=${this.currentPage}`;
                this.$http
                .get(URL)
                .then((result) => {
                    this.table = result.data.data;
                    this.meta = result.data.meta
                })
                .then(data => {
                    console.log(data);
                    this.file = data;
                })
            },

            // separated 2
            handlePageChange(value) {
                console.log(value)
                this.currentPage = value;
                this.getTable(this.saveFilter)

            },

            // separated 3
            // fetchTable() {
            //     const apiUrl = "api/reports/customer-report/table?start=2022-01-01&end=2022-12-31";
            //     this.$http.get(apiUrl)
            //     .then((result) => {
            //         this.cook = result.data.data;
            //     })
            //     .then(data => {
            //         console.log(data);
            //         this.file = data;
            //     })
            // },

            sort:function(s) {
            //if s == current sort, reverse
            if(s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
            }
            this.currentSort = s;
            },

            nextPage:function() {
            if((this.currentPage*this.pageSize) < this.table.data.length) this.currentPage++;
            },
            prevPage:function() {
            if(this.currentPage > 1) this.currentPage--;
            },
        },
        computed: {
            totalPages() {
                return Math.ceil(this.table.length / this.pageSize);
            },
            sortedTable() {
                return this.table.sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                })
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .table td, .table th{
        text-align: center;
    }

    .box-content {
        padding: 20px;
        border-radius: 10px;
    }

    #fileimg {
        justify-content: space-evenly;
        width: 50%;
        align-items: center;
    }
</style>